import Home from '../components/Home'
import Clients from '../components/Clients/Clients'
import Client from '../components/Clients/Client'
import ClientList from '../components/Clients/ClientList'
import ClientView from '../components/Clients/ClientView'
import ClientForm from '../components/Clients/ClientForm'
import Articles from '../components/Articles/Articles'
import Article from '../components/Articles/Article'
import ArticleList from '../components/Articles/ArticleList'
import ArticleView from '../components/Articles/ArticleView'
import ArticleForm from '../components/Articles/ArticleForm'
import Cameras from '../components/Cameras/Cameras'
import Camera from '../components/Cameras/Camera'
import CameraList from '../components/Cameras/CameraList'
import Devices from '../components/Devices/Devices'
import Device from '../components/Devices/Device'
import DeviceList from '../components/Devices/DeviceList'
import ErrorPage from '../components/ErrorPage'

module.exports = [
  { path: '/', component: Home },
  { path: '/clients',
    component: Clients,
    children: [
      { path: '', component: ClientList },
      { path: 'create', component: ClientForm, props: {update: false} },
      {
        path: ':client_id(\\d+)',
        component: Client,
        children: [
          { path: '', component: ClientView },
          { path: 'edit', component: ClientForm, props: {update: true} },
          { path: 'articles',
            component: Articles,
            children: [
              { path: '', component: ArticleList },
              { path: 'create', component: ArticleForm, props: {update: false} },
              { path: ':article_id(\\d+)',
                component: Article,
                children: [
                  { path: '', component: ArticleView },
                  { path: 'edit', component: ArticleForm, props: {update: true} }
                ]
              }
            ]
          },
          {
            path: 'devices',
            component: Devices,
            children: [
              { path: '', component: DeviceList },
              { path: ':device_id(\\d+)', component: Device }
            ]
          },
          {
            path: 'cameras',
            component: Cameras,
            children: [
              { path: '', component: CameraList },
              { path: ':camera_id(\\d+)', component: Camera }
            ]
          }
        ]
      }
    ]
  },
  { path: '*', components: {fullscreen: ErrorPage} }
]



// WEBPACK FOOTER //
// ./src/modules/routes.js